import { Input, Directive } from '@angular/core';
import {
  CdkCell,
  CdkCellDef,
  CdkColumnDef,
  CdkFooterCell,
  CdkHeaderCell,
  CdkFooterCellDef,
  CdkHeaderCellDef,
} from '@angular/cdk/table';

@Directive({
  selector: '[appTableCellDef]',
  providers: [{ provide: CdkCellDef, useExisting: TableCellDef }],
})
export class TableCellDef extends CdkCellDef {}

@Directive({
  selector: '[appTableHeaderCellDef]',
  providers: [{ provide: CdkHeaderCellDef, useExisting: TableHeaderCellDef }],
})
export class TableHeaderCellDef extends CdkHeaderCellDef {}

@Directive({
  selector: '[appTableFooterCellDef]',
  providers: [{ provide: CdkFooterCellDef, useExisting: TableFooterCellDef }],
})
export class TableFooterCellDef extends CdkFooterCellDef {}

@Directive({
  selector: '[appTableColumnDef]',
  providers: [{ provide: CdkColumnDef, useExisting: TableColumnDef }],
})
export class TableColumnDef extends CdkColumnDef {
  @Input('appTableColumnDef')
  override get name(): string {
    return this._name;
  }
  override set name(name: string) {
    this._setNameInput(name);
  }

  protected override _updateColumnCssClassName(): void {
    super._updateColumnCssClassName();
    this._columnCssClassName!.push(`app-table-column-${this.cssClassFriendlyName}`);
  }
}

@Directive({
  selector: 'app-table-header-cell, th[appTableHeaderCell]',
  host: {
    class: 'app-table-header-cell',
    role: 'columnheader',
    '[class]': '"app-table-header-cell_align-" + textAlign',
  },
})
export class TableHeaderCell extends CdkHeaderCell {
  @Input()
  textAlign: 'left' | 'center' | 'right' = 'left';
}

@Directive({
  selector: 'app-table-footer-cell, td[appTableFooterCell]',
  host: {
    class: 'app-table-footer-cell',
  },
})
export class TableFooterCell extends CdkFooterCell {}

@Directive({
  selector: 'app-table-cell, td[appTableCell]',
  host: {
    class: 'app-table-cell',
    '[class]': '"app-table-cell_align-" + textAlign',
  },
})
export class TableCell extends CdkCell {
  @Input()
  textAlign: 'left' | 'center' | 'right' = 'left';
}
